// extracted by mini-css-extract-plugin
export default {"root":"_25aWp","expanded":"_1xOiB"};